import React from 'react';

const LeftArrowIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`text-v3-black-max ${className}`}
      {...props}
    >
      <path 
        d="M20 12H4M4 12L10 6M4 12L10 18" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeftArrowIcon;
